import { Price } from '../types/price';
import { decodeHtml } from './decode-html';

export function getRetailPrice(htmlRootElement: HTMLElement): number | null {
    const price = htmlRootElement?.getAttribute('data-retail-price') || '';
    return !price ? null : +price;
}

export function getBenefitData<T>(rootElement: HTMLElement): T[] {
    const benefitDataString = rootElement?.getAttribute('data-benefit-data');

    if (!benefitDataString) {
        throw new Error('no benefit data found on data attribute');
    }

    try {
        return JSON.parse(decodeHtml(benefitDataString));
    } catch (_) {
        throw new Error('could not decode and parse prices from data attribute');
    }
}

export function getPriceByBenefitId(rootHtmlElement: HTMLElement, benefitId: string): number {
    const benefitData: Price[] = getBenefitData(rootHtmlElement);
    return benefitData?.find(data => data.benefitId === `${benefitId}`)?.retailPrice || 0;
}
